import { render, staticRenderFns } from "./BaseBranchHeader.vue?vue&type=template&id=7017dd36&"
import script from "./BaseBranchHeader.vue?vue&type=script&lang=js&"
export * from "./BaseBranchHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseBranchHeader.vue?vue&type=style&index=0&id=7017dd36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports